import React from "react";
import DashboardGreeting from "@/components/DashboardGreeting";
import { Wrench, Info } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * FutureShopShell — dashboard variant for users whose role class has
 * `is_future_shop_role=true`. Activates for the exact role slugs defined
 * in `/app/backend/seed/seed_rbac.py` (13 slugs, quoted in the deliverable
 * table). Renders a single "Shop Operations — Future Module" tile.
 *
 * The widget-add / catalog-customization UI is NOT rendered here — this
 * shell simply omits it (no code path invokes it). No hacks required.
 */

export default function FutureShopShell({ perspectiveLabel }) {
  const { user } = useAuth();
  return (
    <div
      className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8"
      data-testid="page-dashboard-future-shop"
    >
      <DashboardGreeting user={user} perspectiveLabel={perspectiveLabel} />

      <div
        data-testid="future-shop-tile"
        className="mt-6 bg-white dark:bg-graphite border border-coach-silver dark:border-graphite rounded-md p-6 flex flex-col sm:flex-row items-start gap-5"
      >
        <div className="shrink-0 w-11 h-11 rounded-md bg-coach-blue/10 dark:bg-coach-blue/20 flex items-center justify-center">
          <Wrench size={20} className="text-coach-blue" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10.5px] uppercase tracking-widest text-steel">
            Coming next phase
          </div>
          <div className="font-display text-xl text-carbon dark:text-road-white mt-1">
            Shop Operations — Future Module
          </div>
          <p className="text-[13.5px] text-steel dark:text-coach-silver mt-2 max-w-xl leading-relaxed">
            Your account and role are prepared for the future Shop
            workspace. Shop workflows will appear here when the Shop phase
            is activated.
          </p>
          <div className="mt-4 flex items-center gap-1.5 text-[11.5px] text-steel">
            <Info size={12} />
            You can continue to sign in and view your profile. No action is
            required.
          </div>
        </div>
      </div>
    </div>
  );
}
